module.exports = __webpack_public_path__ + "images/icon/close_dark_blue-1c0462c9.svg";